export enum ShippingType {
    Waybill = 'waybill',
    BillOfLading = 'bill-of-lading',
}
